import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>404 - Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <Link to={'/'}>Return Home</Link>
    </div>
  );
}
